import { ListMessageMessageSets, ListMessageMessageSetsVariables } from './__generated__/ListMessageMessageSets'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMessageMessageSets($cursor: String, $messageId: String!) {
    listSearchMessagesV2(input: { types: [MessageSetMessage], cursor: $cursor, messageId: $messageId }) {
      searchMessages {
        ... on MessageSetMessageV2 {
          id
          messageSet {
            id
            title
          }
        }
      }
      nextCursor
    }
  }
`

export const useListMessageMessageSets = (messageId: string) => {
  return useQuery<ListMessageMessageSets, ListMessageMessageSetsVariables>(QUERY, {
    variables: { messageId }
  })
}
